<ng-container *transloco="let t">
  <div class="flex flex-col gap-2">
    <!-- Label -->
    @if (props.label) {
      <label [for]="id" class="font-semibold">
        {{ props.label }}
        <span class="text-red-500" *ngIf="isRequired()">*</span>
      </label>
    }

    <!-- Radio buttons -->
    <div class="flex flex-col gap-3" role="radiogroup" [attr.aria-labelledby]="id">
      @for (option of radioOptions; track option.value) {
        <button
          class="flex items-center gap-2"
          [class.opacity-50]="isDisabled(option)"
          [class.pointer-events-none]="isDisabled(option)"
        >
          <p-radioButton
            [inputId]="id + '_' + option.value"
            [name]="id"
            [value]="option.value"
            [formControl]="formControl"
          ></p-radioButton>
          <label [for]="id + '_' + option.value">
            {{ option.label }}
          </label>
        </button>
      }
    </div>

    <!-- Description -->
    @if (props.description) {
      <div class="text-sm text-surface-600 dark:text-surface-200 mt-1">
        {{ props.description }}
      </div>
    }

    <!-- Validation Message -->
    @if (isInvalid()) {
      <div class="text-red-500 text-sm">
        <span>{{ t("app.formly-types.validationMessages.fieldRequired") }}</span>
      </div>
    }
  </div>
</ng-container>
